module.exports = __webpack_public_path__ + "img/grey.771e67e.svg";